import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader";
import { projectStatus, freelancerStatus } from "../../utils/data";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import {
  fetchFreelancerProjectDetails,
  fetchMyProjects,
  fetchProjectDetails,
  fetchProjectDliveableFreelancerDetails,
  markAsCompleteProject,
  markAsStartProject,
  uploadDeliverableData,
} from "../../redux/features/find-a-job/actions/projectAction";
import PaginationDropdown from "../../components/table/PaginationDropdown";
import ReactPagination from "../../components/table/ReactPagination";
import NoRecord from "../../components/form/NoRecord";
import ProjectDetails from "../../components/Modals/common/project/ProjectDetails";
import { setIsViewProjectDetails } from "../../redux/features/find-a-job/reducers/projectReducer";
import MarkAsCompleteModal from "../../components/Modals/hire-talent/MarkAsCompleteModal";
import MarkCompleteConfirmationModal from "../../components/Modals/hire-talent/MarkCompleteConfirmationModal";
import UploadDeliveableModal from "../../components/Modals/hire-talent/UploadDeliveableModal";
import SendMessageModal from "../../components/Modals/SendMessageModal";
import { sendMessageSocket } from "../../redux/features/chat/chatSocketHandlers";
import { getSocket } from "../../redux/features/chat/socket";
import { SocketBootstrap } from "../../components/chat/SocketBootstrap";
import { setActiveChat } from "../../redux/features/chat/chatSlice";
import toast from "react-hot-toast";

const MyProjects = () => {
  const socket = getSocket();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  const [searchFilter, setSearchFilter] = useState("");
  const [projectId, setProjectId] = useState("");
  const [currentReceiverId, setCurrentReceiverId] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  const [isSendMessage, setIsSendMessage] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [selectProject, setSelectProject] = useState('');

  const { projectList, projectData, isLoading, isViewProjectDetails, deliveableList } = useSelector(
    (state) => state?.freelancer?.project
  );
  const tabs = [
    {
      label: "All Projects",
      value: "all",
    },
    ...freelancerStatus,
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].value);

  const paginatedList = projectList[activeTab]
    ?.filter((item) => {
      const matchSearchName =
        !searchFilter ||
        item?.project_title?.toLowerCase().includes(searchFilter.toLowerCase());
      return matchSearchName;
    })
    ?.slice(currentPage * listPerPages, (currentPage + 1) * listPerPages);

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  useEffect(() => {
    dispatch(fetchMyProjects());

    return () => {
      dispatch(setActiveChat(null));
    };
  }, []);

  const handleMarkAsComplete = (project_id) => {
    const callback = (res) => {
      if (res?.success) {
        setIsSuccess(true);
        dispatch(fetchMyProjects());
      } else {
        setIsSuccess(false);
      }
    };
    dispatch(
      markAsCompleteProject({
        payload: { project_id },
        callback,
      }),
    );
  };

  const handleStartProject = (project_id) => {
    const callback = (res) => {
      dispatch(fetchMyProjects());
    };
    dispatch(
      markAsStartProject({
        payload: { project_id, action: "on_going" },
        callback,
      }),
    );
  };

  const handleUploadDeliveablesData = (values) => {
    const callback = (response) => {
      setIsUpload(false)
      dispatch(fetchMyProjects());
    };
    const formData = new FormData();
    formData.append("project_id", selectProject);
    values.comment && formData.append("comment", values.comment);
    values.link && formData.append("links", values.link);
    values?.files?.length != 0 &&
      values?.files?.map((item) => formData.append("files", item));
    dispatch(uploadDeliverableData({ payload: formData, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <FreelancerLayout>
        <SocketBootstrap role="freelancer" />
        <div className="ct_px_40 mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h4 class="mb-0 ct_fs_20">My Projects</h4>
                <div
                  className="d-flex align-items-center gap-3 justify-content-between mb-3 ct_mt_20 ct_flex_col_991 "
                  style={{ borderBottom: "1px solid #ccc" }}
                >
                  <div>
                    <ul class="ct_table_filter border-0 ">
                      {tabs?.map((item, index) => (
                        <li
                          onClick={() => setActiveTab(item?.value)}
                          class={`ct_cursor_pointer ${
                            activeTab == item?.value ? "active" : ""
                          }`}
                        >
                          {item?.label}{" "}
                          {`(${projectList[item?.value]?.length || 0})`}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="d-flex align-items-center gap-3 ct_flex_col_767 ct_w_100_767 mb-3 mb-lg-md">
                    <div class="position-relative ct_w_100_767">
                      <input
                        type="text"
                        class="form-control ct_input ct_h_35 ps-5"
                        placeholder="Search by Title"
                        onChange={(e) => setSearchFilter(e.target.value)}
                        value={searchFilter}
                      />
                      <i class="fa-solid fa-search ct_input_icon_left"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row ct_mt_30">
                <div className="col-xl-11">
                  <div className="row">
                    {paginatedList?.length > 0 && (
                      <>
                        {paginatedList?.map((item, index) => (
                          <div className="col-lg-4 col-md-6 ct_mb_30 ct_cursor_pointer">
                            <div className="ct_outline_bg d-grid h-100 ct_py_20_px_30 ct_border_radius_10">
                              <div>
                                <div className="d-flex align-items-center gap-3 justify-content-between">
                                  <div className="">
                                    <h4 className="ct_fs_18 ct_darkblue_text ct_mb_10">
                                      {item?.project_title || ""}
                                    </h4>
                                    <p
                                      className="mb-0 ct_fs_14 ct_grey_text ct_para_scroll ct_custom_scroll"
                                      style={{ maxHeight: "80px" }}
                                    >
                                      {item?.project_description || ""}
                                    </p>
                                  </div>
                                  <div class="ct_right_dropdown dropdown">
                                    <button
                                      id="dropdownMenuButton"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      className="ct_project_action_elipse_icon"
                                    >
                                      <i class="fa-solid fa-ellipsis"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            dispatch(
                                              fetchFreelancerProjectDetails({
                                                payload: item?.id,
                                              }),
                                            );
                                            dispatch(
                                              fetchProjectDliveableFreelancerDetails(
                                                {
                                                  payload: item?.id,
                                                },
                                              ),
                                            );
                                          }}
                                        >
                                          View Project Details
                                        </a>
                                      </li>
                                      {item?.invite_status != "rejected" &&
                                        item?.invite_status != "inreview" && (
                                          <li>
                                            <a
                                              class="dropdown-item ct_darksky_blue_text"
                                              onClick={() => {
                                                setSelectProject(item?.id);
                                                setIsUpload(true);
                                              }}
                                            >
                                              Upload Deliverable
                                            </a>
                                          </li>
                                        )}
                                      <li
                                        onClick={() => {
                                          if (item?.invite_status === "invited") {
                                            toast.error(
                                              "Please accept the project invitation first to start messaging.",
                                            );
                                            return;
                                          }

                                          if (item?.invite_status === "rejected") {
                                            toast.error(
                                              "You cannot send a message because you rejected the project invitation.",
                                            );
                                            return;
                                          }

                                          setCurrentReceiverId(
                                            item?.created_by,
                                          );
                                          setIsSendMessage(true);
                                        }}
                                      >
                                        <a class="dropdown-item ct_yellow_text">
                                          Send Message
                                        </a>
                                      </li>
                                      {(activeTab == "todo" ||
                                        item?.invite_status == "accepted") && (
                                        <li>
                                          <a
                                            class="dropdown-item ct_orange_text"
                                            data-bs-target="#ct_markas_start_modal"
                                            data-bs-toggle="modal"
                                            onClick={() => {
                                              setProjectId(item?.id);
                                            }}
                                            href="javascript:void(0)"
                                          >
                                            Start Project
                                          </a>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                                <div className="ct_mt_16">
                                  <ul className="d-flex align-items-center gap-2 flex-wrap">
                                    {item?.project_categories?.map((cat) => (
                                      <li>
                                        <span
                                          className="ct_badge ct_border_radius_10 ct_fs_14 d-inline-block  ct_darksky_blue_text"
                                          style={{
                                            backgroundColor:
                                              "hsl(199.09deg 63.77% 72.94% / 10%)",
                                            borderColor: "#E1E4EA",
                                          }}
                                        >
                                          {cat}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="d-flex align-items-center justify-content-between gap-3 mt-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <img src="../assets/img/grey_clock_icon.svg" />
                                    <p className="mb-0 ct_fs_12 ct_grey_text">
                                      {`${item?.project_duration} ${item?.duration_type}` ||
                                        ""}
                                    </p>
                                  </div>
                                  {/* <p className="mb-0 ct_fs_12 ct_grey_text">D-18</p> */}
                                </div>
                              </div>
                              <div className="mt-auto">
                                <div className="d-flex align-items-center justify-content-between gap-3 ct_mt_18">
                                  <div className="d-flex align-items-center justify-content-between gap-3 ct_flex_1">
                                    <div className="d-flex align-items-center gap-2">
                                      <div className="d-flex align-items-center gap-2">
                                        <div className="ct_comments_user_img">
                                          <img
                                            src="../assets/img/Avatar_09.png"
                                            className="ct_img_30"
                                          />
                                          <img
                                            src="../assets/img/Avatar_10.png"
                                            className="ct_img_30"
                                          />
                                          <img
                                            src="../assets/img/Avatar_11.png"
                                            className="ct_img_30"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className="ct_cursor_pointer"
                                        data-bs-target="#ct_add_comment_modal"
                                        data-bs-toggle="modal"
                                      >
                                        <img src="../assets/img/outline_plus_icon.svg" />
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 justify-content-between">
                                      <p className="ct_fs_14 mb-0 ct_grey_text">
                                        14 Comments
                                      </p>
                                      <div>
                                        <img src="../assets/img/humbleicons_chat.svg" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                    {paginatedList?.length == 0 && <NoRecord />}
                    {paginatedList?.length > 0 && (
                      <div className="d-flex justify-content-between align-items-center mt-4 ">
                        <div>
                          <PaginationDropdown
                            onChange={(val) => {
                              setListPerPages(val);
                              setCurrentPage(0);
                            }}
                          />
                        </div>
                        <div>
                          <ReactPagination
                            pageCount={Math.ceil(
                              projectList[activeTab]?.length / listPerPages,
                            )}
                            onPageChange={handlePageClick}
                            currentPage={currentPage}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FreelancerLayout>

      {isSuccess && <MarkAsCompleteModal onClose={() => setIsSuccess(false)} />}

      {
        isViewProjectDetails && (
          <ProjectDetails
            onClose={() => {
              dispatch(setIsViewProjectDetails(false));
            }}
            setConfirmation={setConfirmation}
            setProjectId={setProjectId}
            deliveableList={deliveableList}
            projectList={projectData}
          />
        )
      }
      {
        confirmation && (
          <MarkCompleteConfirmationModal
            onClose={() => setConfirmation(false)}
            projectId={projectId}
            handleMarkAsComplete={(data) => handleMarkAsComplete(data)}
          />
        )
      }
      {isUpload &&
        <UploadDeliveableModal
          onClose={() => setIsUpload(false)}
          handleUploadDeliveablesData={handleUploadDeliveablesData}
        />
      }

      {isSendMessage && (
        <SendMessageModal
          onClose={() => {
            setIsSendMessage(false);
          }}
          hendleSendMessage={(text) => {
            socket?.emit("send_message", {
              receiver_id: currentReceiverId,
              message_text: text,
            });

            setIsSendMessage(false);
          }}
        />
      )}
      <div
        class="modal fade ct_markas_start_modal"
        id="ct_markas_start_modal"
        tabindex="-1"
        aria-labelledby="ct_markas_start_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ">
                  Are you sure you want to start this project?
                </h4>
                <p
                  className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                  style={{ maxWidth: "388px" }}
                >
                  Once started, the client will be notified that the project is
                  now in progress.
                </p>
              </div>
              <div class="d-flex align-items-center gap-3 justify-content-center ct_mt_30 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  class="ct_yellow_btn px-5 ct_h_44"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    handleStartProject(projectId);
                  }}
                  type="button"
                >
                  Start
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Project Upload Sucess Modal S */}
      <div
        class="modal fade ct_markas_complete_modal"
        id="ct_markas_complete_modal"
        tabindex="-1"
        aria-labelledby="ct_markas_complete_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ">Mark this Project as Complete?</h4>
                <p
                  className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                  style={{ maxWidth: "388px" }}
                >
                  Confirm that you’ve finished this project. The client will be
                  notified for final review
                </p>
              </div>
              <div class="d-flex align-items-center gap-3 justify-content-center ct_mt_30 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  class="ct_yellow_btn px-5 ct_h_44"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    handleMarkAsComplete(projectId);
                  }}
                  type="button"
                >
                  Mark as Complete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Project Upload Sucess Modal E */}
      {/* ct_project_marked_modal Modal S */}
      <div
        class="modal fade ct_markas_complete_modal"
        id="ct_project_marked_modal"
        tabindex="-1"
        aria-labelledby="ct_project_marked_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ">Project Marked</h4>
                <p
                  className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                  style={{ maxWidth: "388px" }}
                >
                  Project marked as complete. Awaiting client review.
                </p>
              </div>
              <div class=" ct_mt_30 w-100 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44 w-100"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Project Upload Sucess Modal E */}

      {/* File Upload Sucess S */}
      <div
        class="modal fade ct_markas_complete_modal"
        id="ct_Upload_file_sucess"
        tabindex="-1"
        aria-labelledby="ct_Upload_file_sucessLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ct_darkblue_text ">Upload Successful</h4>
                <p className="ct_fs-14 ct_grey_text mb-0 mx-auto">
                  Deliverable submitted to client successfully
                </p>
              </div>
              <div class=" ct_mt_30 w-100 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44 w-100"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* File Upload Sucess E */}

      {/* * add comment  modal S */}
      <div
        class="modal fade modal-lg"
        id="ct_add_comment_modal"
        tabindex="-1"
        aria-labelledby="ct_add_comment_modalLabel"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered"
          style={{ maxWidth: "600px" }}
        >
          <div class="modal-content ct_p_30 ct_border_radius_20">
            <div class="modal-header border-0 p-0 ct_mb_30">
              <div>
                <h4 class="mb-1 ct_fs_20">Add Comment</h4>
                <p class="mb-0 ct_grey_text">
                  Leave a note or update for the enterprise client
                </p>
              </div>
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body p-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="ct_mb_20">
                    <ul>
                      <li className="d-flex align-items-center gap-3 mb-2">
                        <p className="mb-0 ct_fs_14 ct_white_nowrap">
                          Project:{" "}
                        </p>
                        <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                          Marketing Campaign - July
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3 mb-2">
                        <p className="mb-0 ct_fs_14 ct_white_nowrap">
                          Enterprise Client :{" "}
                        </p>
                        <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                          {" "}
                          Acme Corporation
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div class="form-group ct_mb_20">
                    <label class="ct_fs_14 ct_darkblue_text mb-2">
                      Comment
                    </label>
                    <textarea
                      class="form-control ct_input h-auto ct_fs_12"
                      rows={4}
                      placeholder="Write your comment or update here...."
                    ></textarea>
                  </div>
                  <div class="form-group ct_mb_20">
                    <label class="ct_fs_14 ct_darkblue_text mb-2">
                      Attach File (Optional)
                    </label>
                    <div
                      class="ct_upload_product_main ct_upload_product_main_180 "
                      style={{ height: "118px" }}
                    >
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                          stroke="#9CA3AF"
                          stroke-width="2.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                      <p class="text-center ct_fs_12 ct_text_op_07 mb-0">
                        Upload Screenshot/ PDF/ Design File
                      </p>
                      <label for="ct_upload_product">
                        <input
                          id="ct_upload_product"
                          class="d-none"
                          type="file"
                          name=""
                        />
                      </label>
                    </div>
                    <div class="ct_single_uploaded_img mt-3 d-none">
                      <img
                        alt=""
                        src="../assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                      />
                      <i class="fa-solid fa-xmark"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-3 justify-content-end ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                  type="button"
                >
                  Cancel
                </button>
                <button
                  class="ct_yellow_btn px-5 ct_h_44"
                  data-bs-target="#ct_comment_added_success"
                  data-bs-toggle="modal"
                  type="button"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* add comment  modal E  */}

      {/* File Upload Sucess S */}
      <div
        class="modal fade ct_markas_complete_modal"
        id="ct_comment_added_success"
        tabindex="-1"
        aria-labelledby="ct_comment_added_successLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ct_darkblue_text ">Comment Added</h4>
                <p className="ct_fs-14 ct_grey_text mb-0 mx-auto">
                  Your Comment has been added to the project
                </p>
              </div>
              <div class=" ct_mt_30 w-100 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44 w-100"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* File Upload Sucess E */}
    </div>
  );
};

export default MyProjects;
